exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".k-combobox .k-dropdown-wrap{height:32px}.k-combobox .k-input{padding-top:5px !important}", ""]);

// exports
